import { HttpClient, HttpErrorResponse, HttpHandler, HttpHeaders, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MonoTypeOperatorFunction, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ErrorNotifierService} from './error-notifier.service';
import {Error} from '../shared/error'

export interface IRequestOptions {
    headers?: HttpHeaders;
    observe?: 'body';
    params?: HttpParams;
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    body?: any;
}

export interface IRequestOptionsBlob {

    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
        [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType: 'blob';
    withCredentials?: boolean;

}

@Injectable()
export class ApplicationHttpClient {

    private http: HttpClient;
    private interceptError = true;

    constructor(private handler: HttpHandler,
                private errorNotifierService: ErrorNotifierService) {
        this.http = new HttpClient(this.handler);
    }

    public static applicationHttpClient(handler: HttpHandler, errorNotifierService: ErrorNotifierService): ApplicationHttpClient {
        return new ApplicationHttpClient(handler, errorNotifierService);
    }

    public static applicationHttpClientWithErrorHandling(
        handler: HttpHandler,
        errorNotifierService: ErrorNotifierService): ApplicationHttpClient {
        const applicationHttpClient = new ApplicationHttpClient(handler, errorNotifierService);
        applicationHttpClient.interceptError = true;
        return applicationHttpClient;
    }

    public get<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
        const httpResponse$ = this.http.get<T>(endPoint, options);
        return this.decorateWithErrorHandling(httpResponse$, this.interceptError);
    }

    public post<T>(endPoint: string, params: any, options?: IRequestOptions): Observable<T> {
        const httpResponse$ = this.http.post<T>(endPoint, params, options);
        return this.decorateWithErrorHandling(httpResponse$, this.interceptError);
    }

    public put<T>(endPoint: string, params: any, options?: IRequestOptions): Observable<T> {
        const httpResponse$ = this.http.put<T>(endPoint, params, options);
        return this.decorateWithErrorHandling(httpResponse$, this.interceptError);
    }

    public delete<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
        const httpResponse$ = this.http.delete<T>(endPoint, options);
        return this.decorateWithErrorHandling(httpResponse$, this.interceptError);
    }

    private decorateWithErrorHandling<R>(http$: Observable<R>, shouldNotify: boolean): Observable<R> {
        let eventHandler: (event: HttpErrorResponse) => void;

        if (shouldNotify) {
            eventHandler = (event) => this.sendToErrorNotifierService(event, this.errorNotifierService);
        } else {
            eventHandler = console.log;
        }

        const errorHandlerPipe = this.tapHttpErrorResponseHandler<R>(eventHandler);

        return http$.pipe(errorHandlerPipe);

    }

    private sendToErrorNotifierService(event: HttpErrorResponse, errorNotifierService: ErrorNotifierService): void {
        const error: Error = Error.fromJSON(event.error as string);
        if (!event || !event.status || event.status < 500) {
            return;
        }
        errorNotifierService.notifyError(error);
    }

    private tapHttpErrorResponseHandler<R>(eventHandler: (event: any) => void): MonoTypeOperatorFunction<R> {
        return tap(
            () => {},
            event => {
                if (event instanceof HttpErrorResponse) {
                    eventHandler(event);
                }
            });
    }
}
